<div style="min-height: 1.7rem;"
     data-pp-message
     [attr.data-pp-amount]="amount"
     data-pp-style-layout="text"
     data-pp-style-logo-type="primary"
     [attr.data-pp-buyercountry]="getBuyerCountry()"
     [attr.data-pp-contextualComponents]="mode === 'basket' && app.multisite.current.country === 'US' ? 'PAY_LATER_BUTTON' : null"
     data-pp-style-logo-position="left">
</div>
